// extracted by mini-css-extract-plugin
module.exports = {"label":"KeywordSearchGroupPrimaryForm_label__1N9cn","sending":"KeywordSearchGroupPrimaryForm_sending__2ZCdi"};